module.exports = __webpack_public_path__ + "img/chevron-top-small.fca200f2.svg";